export const env = {
    production: true,
    URL_FRONT: 'https://motordesk.ru',
    URL_LK: 'https://lk.motordesk.ru',
    URL_LK_REGISTER: 'https://lk.motordesk.ru/register',
    URL_LK_DEMO: 'https://lk.motordesk.ru/demo',
    URL_API: 'https://api.motordesk.ru',
    BOT_NAME: '@MotorDeskBot',
    BOT_URL: 'https://t.me/MotorDeskBot',
    CHANNEL_NAME: '@MotorDeskChannel',
    CHANNEL_URL: 'https://t.me/MotorDeskChannel',
    CONTACT_EMAIL: 'motordesk@yandex.ru',
    METRIKA_COUNTER_ID: 99228740,
    METRIKA_ENABLED: true,
};

export const environment = env;
